import { Link } from 'react-router-dom';
// import LowInventoryStockListItem from './LowInventoryStockListItem';

function LowInventoryStock() {
    return (
        <div className="border rounded-lg border-[#EAEAEA] col-span-2 min-h-[50vh] pt-4 pb-2 flex flex-col gap-4">
            <div className="flex items-center justify-between px-4">
                <h1 className="font-semibold text-base">Low Inventory Stock</h1>

                <Link to='/report-and-analytics/low-inventory-products' className="text-[#1055EB] font-semibold text-[12px] leading-6" href="/">View all</Link>
            </div>

            <div className="m-auto">
                <h1 className='font-normal italic text-base text-[#666666]'>Available soon</h1>
            </div>

            <div className="flex flex-col">
                {/* <LowInventoryStockListItem 
                    product={productInfo}
                />
                <LowInventoryStockListItem 
                    product={productInfo}
                />
                <LowInventoryStockListItem 
                    product={productInfo}
                />
                <LowInventoryStockListItem 
                    product={productInfo}
                />
                <LowInventoryStockListItem 
                    product={productInfo}
                /> */}
            </div>
        </div>
    );
}

export default LowInventoryStock;
